import { render, staticRenderFns } from "./DoughnutContainer.vue?vue&type=template&id=7b9a5fe0&"
import script from "./DoughnutContainer.vue?vue&type=script&lang=js&"
export * from "./DoughnutContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports